export class LendersRequest {
  //#region : Constructor :
  constructor(dealerCode?: string, userName?: string) {
    this.dealerCode = dealerCode;
    this.userName = userName;
  }
  //#endregion

  //#region : Properties :
  public userName: string;
  public dealerCode: string;
  //#endregion
}
